(function () {
  var SEL = '[data-kit-carousel]';

  function init(root) {
    if (root.dataset.kitInit === '1') return;
    root.dataset.kitInit = '1';

    var viewport = root.querySelector('.kit-carousel__viewport');
    var track = root.querySelector('[data-kit-track]');
    if (!viewport || !track) return;

    var cards = Array.from(track.querySelectorAll('[data-kit-card]'));
    if (cards.length === 0) return;

    var dots = Array.from(root.querySelectorAll('[data-kit-dot]'));
    var prevBtn = root.querySelector('[data-kit-prev]');
    var nextBtn = root.querySelector('[data-kit-next]');
    var startIdx = parseInt(root.dataset.startIndex, 10) || 1;
    startIdx = Math.max(0, Math.min(startIdx - 1, cards.length - 1));
    var currentIndex = startIdx;

    function goTo(index, smooth) {
      if (smooth === undefined) smooth = true;
      if (index < 0) index = cards.length - 1;
      if (index >= cards.length) index = 0;
      currentIndex = index;
      var card = cards[index];
      var cardCenter = card.offsetLeft + card.offsetWidth / 2;
      var target = cardCenter - viewport.clientWidth / 2;
      viewport.scrollTo({ left: Math.max(0, target), behavior: smooth ? 'smooth' : 'auto' });
      updateDots();
    }

    function updateDots() {
      dots.forEach(function (dot, i) {
        var active = i === currentIndex;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function syncFromScroll() {
      var center = viewport.scrollLeft + viewport.clientWidth / 2;
      var closest = 0;
      var closestDist = Infinity;
      cards.forEach(function (card, i) {
        var mid = card.offsetLeft + card.offsetWidth / 2;
        var d = Math.abs(mid - center);
        if (d < closestDist) { closestDist = d; closest = i; }
      });
      if (closest !== currentIndex) { currentIndex = closest; updateDots(); }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.dataset.kitDot, 10) || 0);
      });
    });

    if (prevBtn) prevBtn.addEventListener('click', function () { goTo(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goTo(currentIndex + 1); });

    var scrollTimer = null;
    viewport.addEventListener('scroll', function () {
      if (scrollTimer) clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 80);
    }, { passive: true });

    root.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { goTo(currentIndex - 1); e.preventDefault(); }
      else if (e.key === 'ArrowRight') { goTo(currentIndex + 1); e.preventDefault(); }
    });

    updateDots();
    goTo(currentIndex, false);

    var resizeTimer = null;
    window.addEventListener('resize', function () {
      if (resizeTimer) clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () { goTo(currentIndex, false); }, 150);
    });
  }

  function boot(scope) {
    (scope || document).querySelectorAll(SEL).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target;
    if (!card || !card.matches || !card.matches('[data-kit-card]')) return;
    var root = card.closest(SEL);
    if (!root) return;
    init(root);
    var viewport = root.querySelector('.kit-carousel__viewport');
    var cards = Array.from(root.querySelectorAll('[data-kit-card]'));
    var idx = cards.indexOf(card);
    if (idx >= 0 && viewport) {
      var cardCenter = card.offsetLeft + card.offsetWidth / 2;
      viewport.scrollTo({ left: Math.max(0, cardCenter - viewport.clientWidth / 2), behavior: 'smooth' });
      root.querySelectorAll('[data-kit-dot]').forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
    }
  });
})();
